export default {
  FixedTabs: {
    name: 'Name:',
    home: 'Home',
    newPolicy: 'Is it a new policy?',
    isNeeedToContactBeforeVisit: 'Needs to be contacted before visit?',
    companySize: 'Company Size',
    jobTitle: 'Job Title',
    bestWayToContactBefore: 'Best way to contact before',
    sellingagent: 'Last Selling Agent:',
    lastDispositionDate: 'Last Disposition Date:',
    leadsDescription: 'Leads Description:',
    appointmentDate: 'Appointment Date/Time:',
    homeBusiness: 'Home Business:',
    address: 'Address',
    emailAddress: 'Email Address:',
    doNotCallAfter: 'Do Not Call After:',
    industry: 'Industry:',
    numberOfEmployees: 'Number Of Employees:',
    currentDisposition: 'Current Disposition:',
    lastAssignedTo: 'Last Assigned To:',
    policyholderTenure: 'Policyholder Tenure:',
    agentNotesDirections: 'Agent Notes/Directions',
    lastDisposition: 'Last Disposition:',
    yearsInBusiness: 'Years In Business:',
    determinate: 'determinate',
    assignedLeads: 'Assigned Leads',
    unAssignedLeads: 'Unassigned Leads',
    closedLeads: 'Closed Leads',
    inspections: 'Inspections',
    myInspections: 'My Inspections',
    teamInspections: 'Team Inspections',
    references: 'References',
    reports: 'Reports',
    drafts: 'Drafts',
    pmaportal: 'PMA Portal',
    accounts: 'Accounts',
    settings: 'Settings',
    logoff: 'Logoff',
    underwritingmanuals: 'Underwriting Manuals',
    customername: 'Customer Name',
    primarycontact: 'Primary Contact:',
    residentialphone: 'Residential Phone:',
    insuredsdob: 'Insured’s DOB:',
    calltype: 'Call Type:',
    residentialaddress: 'Residential Address:',
    alternatephone: 'Alternate Phone:',
    age: 'Age:',
    writingagent: 'Writing Agent',
    writingagentsmanager: 'Writing Agent’s Manager',
    languagepreference: 'Language Preference:',
    languagepreferenceIns: 'Language Preference',
    writingagentcode: 'Writing Agent Code',
    appdate: 'App Date',
    initialpaymenttype: 'Initial Payment Type',
    recurringpaymenttype: 'Recurring Payment Type',
    policytype: 'Policy Type',
    grossannualhouseholdincome: 'Gross Annual Household Income',
    apv: 'APV',
    language: 'Language:',
    monthlypremiuim: 'Monthly Premium',
    grossindividualannualincome: 'Gross Annual Individual Income',
    premiummode: 'Premium Mode',
    contactinfo: 'Contact Info:',
    businessinfo: 'Business Info:',
    premiumbillingdate: 'Preferred Billing Date',
    policydetails: 'Policy Details',
    valueAddProductsOwned: 'Value Add Products Owned:',
    businessname: 'Business Name:',
    businessphone: 'Business Phone:',
    businessaddress: 'Business Address:',
    occupation: 'Occupation:',
    script: 'Script',
    customerexperience: 'Customer Experience',
    trainingopportunity: 'Training Oppurtunity',
    nocontact: 'No Contact',
    comments: 'Comments',
    duplicateinspection: 'Duplicate Inspection',
    submit: 'Submit',
    leadtype: 'Lead Type:',
    whatcustomerexperience: 'What was the Customer\'s Experience?',
    trainingopportunityassociated: 'Select the training opportunities that are associated with this Inspection',
    couldnotcontact: 'Select the reason for No Contact.',
    duplicateinspectiontext: 'Please select SAVE to confirm that this is a Duplicate Inspection, if not select CANCEL',
    submitreviewtext: 'Please review the Inspection information before submitting or select Cancel to edit:',
    submitpaymenttext: 'Reviewed monthly Premium amount, billing date, and Payment method with the Policyholder',
    campaignName: 'Campaign Name:',
    payment: 'Payment',
    recommendedBestProductToSell: 'Recommended Best Product To Sell:',
    recommendedNextBestProductToSell: 'Recommended Next Best Product To Sell:',
    campaignPurpose: 'Campaign Purpose:',
    attemptedContacts: 'Attempted Contacts',
    appointment: 'Appointment',
    sale: 'Sale',
    noSale: 'No Sale',
    edit: 'Edit',
    save: 'Save',
    cancel: 'Cancel',
    poor: '1 Poor',
    rich: '5 Excellent',
    selectallthatapply: 'Select all that apply',
    affordability: 'Affordability',
    productknowledge: 'Product Knowledge',
    needsbasedselling: 'Needs Based Selling',
    billingprocess: 'Billing Process',
    paymentmode: 'Payment Mode',
    familybusiness: 'Friend/Family Business',
    leftmessage: 'Left Message',
    policyCancelled: 'Policy Cancelled',
    badphonenumber: 'Bad Phone Number',
    inspnotrequired: 'Inspection Not Required',
    timeofsale: 'Inspector Present at Time of Sale',
    estROPMailDate: 'Est. ROP Mail Date:',
    estROPInHomeDate: 'Est. ROP In-Home Date:',
    rOPPolicy: 'ROP Policy #:',
    rOPProductName: 'ROP Product Name:',
    rOPModePremium: 'ROP Mode Premium:',
    rOPBillingMode: 'ROP Billing Mode:',
    rOPRange: 'ROP Range:',
    rOPBenefitRecycle: 'ROP Benefit Recycle:',
    otherPoliciesToOffer: 'Other Policies To Offer:',
    dispositionNoSale: 'Disposition - No sale',
    dispositionSale: 'Disposition - sale',
    editLead: 'Edit Lead',
    contactInfo: 'Contact Info',
    residentialInfo: 'Residential Info',
    policyDetails: 'Policy Details',
    businessInfo: 'Business Info',
    other: 'Other',
    campaignDescription: 'Campaign Description',
    inforcePolicies: 'Inforce Policies:',
    policyNo: 'Policy #',
    formNo: 'Form #',
    policy: 'Policy',
    benefit: 'Benefit',
    premium: 'Premium',
    mode: 'Mode',
    t: 'T',
    issueDate: 'Issue Date',
    insuredName: 'Insured\'s Name',
    insuredNameIns: 'Insured\'s Name',
    state: 'State',
    city: 'City',
    country: 'Country',
    leadType: 'LeadType',
    streetAddress: 'StreetAddress',
    zip: 'Zip',
    status: 'Status',
    assignedTo: 'AssignedTo',
    isOrphaned: 'isOrphaned',
    disposition: 'Disposition',
    description: 'Description',
    lastSelling: 'LastSelling',
    lastassignedagentCode: 'LastAssignedAgentCode',
    lapsedPolicies: 'Lapsed Policies:',
    lapseDate: 'Lapse Date',
    none: 'None',
    noLeadsAssigned: 'No Leads Assigned',
    showing: 'Showing',
    of: 'Of',
    clearFilter: 'Clear Filters',
    notes: 'Notes:',
    searchAddress: 'Search Address',
    searchName: 'Search Name',
    search: 'Search',
    searchNameManage: 'Search Name',
    searchAddressManage: 'Search Address',
    searchPhone: 'Search Phone',
    forMoreInfo: '*For more information please view the Policy Details page',
    days: 'Days',
    day: 'Day',
    combinedProducts: 'Note: Ask about other Combined products to ensure affordability.',
    selectionRequired: 'Selection Required',
    searchInsuredName: 'Search Insured\'s Name',
    searchWritingAgent: 'Search Writing Agent',
    insuredsName: 'Insured\'s Name',
    product: 'Product',
    select: 'Selection Required',
    ok: 'OK',
    streetaddress: 'Street Address',
    records: 'records',
    record: 'record',
    selected: 'selected',
    checking: 'Checking Account',
    creditDebitCard: 'Credit/Debit Card',
    inspectionScriptHeader: 'INSPECTION CALL SCRIPT',
    noInspectionsFound: 'No Inspections found',
    dateofapp: 'Date Of App',
    deleteString: 'Are you sure you want to delete this personal lead?',
    stateOpen: 'State:',
    cityOpen: 'City:',
    zipOpen: 'Zip:',
    priorityLeadsTab: 'Priority Leads',
    openLeadsTab: 'Open Leads',
    closedViewTabCheck: 'No Closed leads to view',
    openLeadsSearchString: 'Please click on search',
    priorityViewTabCheck: 'No Priority leads available',
    hippa: 'HIPAA Customer:',
    campaignType: 'Campaign Type'
  },
  Assign: {
    selectall: 'Select All',
    name: 'Name',
    state: 'State',
    county: 'County',
    city: 'City',
    zip: 'Zip',
    leadtype: 'Lead Type',
    campaign: 'Campaign',
    campaignType: 'Campaign Type',
    language: 'Language',
    streetaddress: 'Street Address',
    lastassigned: 'Last Assigned To',
    sellingagent: 'Last Selling Agent',
    assignedto: 'Assigned To:',
    assignmentSource: 'Assignment Source',
    disposition: 'Disposition',
    lineOneManager: 'Active Line 1 Manager',
    activeLastSellingAgentName: 'Active Last Selling Agent',
    isOrphaned: 'Show Orphaned Leads?',
    isOrphanedHintText: 'Show Orphaned Leads?',
    customername: 'Customer Name',
    calltype: 'Call Type',
    phoneNumber: 'Phone Number',
    writingagent: 'Writing Agent',
    division: 'Division-Market',
    product: 'Product',
    appdate: 'App Date',
    dateofapp: 'Date Of App',
    expires: 'Expires',
    assignto: 'Assign To',
    dmsc: 'DM/SC',
    agent: 'Agent',
    insuredName: 'Insured\'s Name',
    selectperson: 'Select Person',
    confirmassign: 'Confirm Assignment',
    reconfirmassign: 'Confirm Re-Assignment',
    search: 'Search',
    person: 'Person',
    unassign: 'Unassign',
    cancel: 'Cancel',
    ok: 'OK',
    reassignedLeads: 'These leads are being re-assigned',
    reassign: 'Re-Assign To:',
    lastassignedDate: 'Last Assigned Date',
    lastassignedDateMD: 'Date MD Assigned',
    dateAssigned: 'Date Assigned',
    tier: 'Tier',
    forMoreInfo: '*For more information please view the Policy Details page',
    hipaaCustomer: 'HIPAA Customer'
  },
  AdminScreen: {
    assignques: 'What market would you like to work as?',
    selectdiv: 'Select Division & Market',
    selectDivision: 'Select Division & Market:',
    leadsquesn: 'Would you like to assign Leads to another Market?',
    yes: 'Yes',
    no: 'No',
    max2: '(Max 2):',
    continue: 'Continue',
    searchText: 'Select Division & Market'
  },
  Manage: {
    selectall: 'Select All',
    name: 'Name',
    state: 'State',
    county: 'County',
    city: 'City',
    zip: 'Zip',
    address: 'Address',
    leadtype: 'Lead Type',
    campaign: 'Campaign',
    language: 'Language',
    streetaddress: 'Street Address',
    lastassigned: 'Last Assigned To',
    sellingagent: 'Last Selling Agent',
    assignedto: 'Assigned To',
    disposition: 'Disposition',
    customername: 'Customer Name',
    calltype: 'Call Type',
    phoneNumber: 'Phone Number',
    writingagent: 'Writing Agent',
    division: 'Division-Market',
    phone: 'Phone',
    product: 'Product',
    appdate: 'App Date',
    dateofapp: 'Date Of App',
    expires: 'Expires',
    tier: 'Tier',
    assignto: 'Assign To',
    dmsc: 'DM/SC',
    agent: 'Agent',
    selectperson: 'Select Person',
    selectState: 'Select State',
    confirmassign: 'Confirm Assignment',
    reconfirmassign: 'Confirm Re-Assignment',
    newPersonalLead: 'New Personal Lead',
    search: 'Search',
    reminderXminutesbefore: 'Reminder \'X\' minutes before',
    stateOpen: 'State:',
    cityOpen: 'City:',
    zipOpen: 'Zip:',
    ok: 'Ok',
    searchCriteriaMsg: 'Please select search criteria',
    openLeadsSearch: 'Where would you like to work?',
    cancel: 'Cancel',
    selectionRequiredHint: 'Selection Required',
    hippa: 'HIPAA Customer:',
    campaignType: 'Campaign Type'
  },
  Popup: {
    title: 'Name',
    location: 'Location',
    startDate: 'Start Date',
    startTime: 'Start Time',
    hour: 'Hour',
    minute: 'Minute',
    meridian: 'AM/PM',
    endDate: 'End Date',
    endTime: 'End Time',
    reminderXminutesbefore: 'Reminder \'X\' minutes before',
    cancel: 'Cancel',
    ok: 'OK',
    policyNum: 'Policy#',
    searchPolicy: 'Search Policy',
    save: 'Save',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    type: 'Type',
    residence: 'Residence',
    business: 'Business',
    address: 'Address',
    dOB: 'DOB',
    update: 'Update',
    editLead: 'Edit Lead',
    home: 'Home',
    additionalNoCell: 'Additional No.(Cell)',
    language: 'Language:',
    calltype: 'Call Type',
    primaryContact: 'Primary Contact:',
    emailAddress: 'Email Address:',
    businessname: 'Business Name:',
    zipCityState: 'Zip / City / State',
    state: 'State',
    city: 'City',
    zip: 'Zip',
    comments: 'Notes',
    none: 'None',
    noLeadsAssigned: 'No Leads Assigned',
    searchAddress: 'Search Address',
    searchName: 'Search Name',
    search: 'Search',
    errorMessage: 'Please fill all the mandatory fields',
    alert: 'Alert',
    pleaseSelectPolicy: 'Please select a policy from the dropbox',
    stateOpen: 'State:',
    cityOpen: 'City:',
    zipOpen: 'Zip:'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/en.js